module.exports = __webpack_public_path__ + "static/media/me3_Diploma.457da6a0.svg";